export default __webpack_public_path__ + "static/media/adjust-amt-sucess.fa04899b.png";